import { Reference, Property, Name, Output, Text } from "@components/Reference";
import Sandbox from "@components/Sandbox";
import { Spacer } from "@cleartrip/bento/lib";
import { Table, TRow, TCol } from '@components/Table';
import * as React from 'react';
export default {
  Reference,
  Property,
  Name,
  Output,
  Text,
  Sandbox,
  Spacer,
  Table,
  TRow,
  TCol,
  React
};